<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.7378 4.79002C12.5258 3.42297 11.5414 2.5 10.0579 2.5H5.24571C3.57046 2.5 2.51807 3.6899 2.51807 5.37081V9.90308C2.51807 11.4344 3.39331 12.5628 4.82831 12.7408"
      stroke="#8F42FF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.755 7.23315H9.94441C8.26837 7.23315 7.2168 8.41983 7.2168 10.0999V14.6322C7.2168 16.3123 8.26271 17.499 9.94441 17.499H14.7542C16.4367 17.499 17.4827 16.3123 17.4827 14.6322V10.0999C17.4827 8.41983 16.4367 7.23315 14.755 7.23315Z"
      stroke="#8F42FF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
